import { render, staticRenderFns } from "./enterpriseGoodsEdit.vue?vue&type=template&id=106eb32c&scoped=true&"
import script from "./enterpriseGoodsEdit.vue?vue&type=script&lang=js&"
export * from "./enterpriseGoodsEdit.vue?vue&type=script&lang=js&"
import style0 from "./enterpriseGoodsEdit.vue?vue&type=style&index=0&id=106eb32c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106eb32c",
  null
  
)

export default component.exports